import { NumberValue } from '../../../../utils'
import type { InvoiceSummary } from '../../types/invoices/invoiceSummary'
import type { InvoiceTotals } from '../../types/invoices/invoiceTotals'

// A final invoice draft has no adjustedSummary. The amount due is the line totals minus the deposit
// invoice summary, which the editor already has.
export const subtractDepositFromLineTotals = (
  lineTotals: InvoiceTotals,
  depositSummary: InvoiceSummary,
): InvoiceTotals => {
  const depositTaxByRate = new Map((depositSummary.foreignTaxSummary ?? []).map((row) => [row.percentage, row.amount]))

  const taxSummary = (lineTotals.taxSummary ?? []).flatMap((row) => {
    const depositTaxAmount = depositTaxByRate.get(row.percentage ?? Number.NaN) ?? 0
    const amount = new NumberValue(row.amount).subtract(depositTaxAmount).getRounded()

    // A 0% rate has no tax to subtract, but the row carries the exemption region.
    return amount === 0 && row.percentage !== 0 ? [] : [{ amount, percentage: row.percentage }]
  })

  return {
    grossTotal: new NumberValue(lineTotals.grossTotal).subtract(depositSummary.foreignGrossTotal).getRounded(),
    netTotal: new NumberValue(lineTotals.netTotal).subtract(depositSummary.foreignNetTotal).getRounded(),
    taxSummary,
    taxTotal: new NumberValue(lineTotals.taxTotal).subtract(depositSummary.foreignTaxTotal).getRounded(),
  }
}
